module.exports = __webpack_public_path__ + "img/1294050000.6b5c35fb.jpg";